import { API_BASE_URL } from './api.js';

export async function fetchPosts({ perPage = 10 } = {}) {
  const response = await fetch(
    `${API_BASE_URL}/posts?per_page=${perPage}&_embed`
  );
  if (!response.ok) throw new Error('Error fetching posts');
  return await response.json();
}

export async function fetchPostBySlug(slug) {
  const response = await fetch(`${API_BASE_URL}/posts?slug=${slug}&_embed`);
  if (!response.ok) throw new Error('Error fetching post');
  const data = await response.json();
  return data[0];
}

export async function fetchPostsByCategoryId(
  categoryId,
  { perPage = 10, page = 1 } = {}
) {
  const response = await fetch(
    `${API_BASE_URL}/posts?categories=${categoryId}&_embed&per_page=${perPage}&page=${page}`
  );
  if (!response.ok) throw new Error('Error fetching posts by category');
  const data = await response.json();
  const totalPages = parseInt(
    response.headers.get('X-WP-TotalPages') || '0',
    10
  );
  return { posts: data, totalPages };
}

export async function fetchPostsByTagId(tagId, { perPage = 10, page = 1 } = {}) {
  const response = await fetch(
    `${API_BASE_URL}/posts?tags=${tagId}&_embed&per_page=${perPage}&page=${page}`
  );
  if (!response.ok) throw new Error('Error fetching posts by tag');
  const data = await response.json();
  const totalPages = parseInt(
    response.headers.get('X-WP-TotalPages') || '0',
    10
  );
  return { posts: data, totalPages };
}

export async function searchPosts(query, { perPage = 10, page = 1 } = {}) {
  const response = await fetch(
    `${API_BASE_URL}/posts?search=${encodeURIComponent(query)}&_embed&per_page=${perPage}&page=${page}`
  );
  if (!response.ok) throw new Error('Error searching posts');
  const data = await response.json();
  const totalPages = parseInt(
    response.headers.get('X-WP-TotalPages') || '0',
    10
  );
  return { posts: data, totalPages };
}